<div class="container-fluid psp-container">
  <div class="card mb-4">
    <div class="row align-items-center pt-3">
      <div class="col-lg-6 col-7">
        <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-3">
          <ol class="breadcrumb breadcrumb-links breadcrumb-dark">
            <li class="breadcrumb-item text-primary psp-breadcrumb">
              <a class="text-primary" [routerLink]="'/patients'"> Patients </a>
            </li>

            <li
              aria-current="page"
              class="text-primary breadcrumb-item psp-breadcrumb"
            >
              Patient Profile
            </li>
            <li
              aria-current="page"
              class="breadcrumb-item active text-gray psp-breadcrumb"
            >
              Request Home Delivery
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div
      class="border-bottom title d-flex p-3 justify-content-between align-items-center mt-2"
    >
      <h1 class="m-0">Request Home Delivery</h1>
    </div>

    <div class="row" *ngIf="selectedSubscription?.statusId === pspSubscriptionStatus.Suspended; else canRequest">
      <div class="col-12 py-3">This patient is flagged that he/she is non-authorized for medication request, please go back to his/her profile to check the data.</div>
    </div>

    <ng-template #canRequest>

      <div class="steps-header d-flex m-3 p-3">
        <div class="step" (click)="stepCount = 1">
        <span class="icon-container" [ngClass]="{ active: stepCount == 1 }">
          <i
                  class="icon-location"
                  [ngClass]="{ 'ico-active': stepCount == 1 }"
          ></i>
        </span>
          <span class="step-title">Step 01</span>
          <span class="step-description">Select Address</span>
        </div>

        <div class="step">
        <span class="icon-container" [ngClass]="{ active: stepCount == 2 }">
          <i class="icon-info" [ngClass]="{ 'ico-active': stepCount == 2 }"></i>
        </span>
          <span class="step-title">Step 02</span>
          <span class="step-description">Request information</span>
        </div>
      </div>

      <ng-template [ngIf]="stepCount == 1">
        <div
                class="row steps-action d-flex flex-column align-items-center justify-content-center"
        >
          <div class="row w-100">
            <div class="col-12 justify-content-start ml-3">
              <h1>Choose An Address Or Add A New One</h1>
            </div>
          </div>

          <form #addressForm="ngForm" id="form">
            <div class="saved-address-container">
              <div
                      class="address-card"
                      *ngFor="let address of addresses; let i = index"
              >
                <div class="card-header">
                  <div
                          class="more-menu-trigger row d-flex justify-content-start pr-3 pl-3"
                  >
                  <span class="select-option mr-1">
                    <input
                            type="radio"
                            name="address-checked"
                            [id]="'address-checked' + i"
                            (change)="onChange(address)"
                            [(ngModel)]="selectedAddress.patientAddressId"
                            [value]="address.patientAddressId"
                            title="Select this address"
                    />
                  </span>
                    <h3 [tooltip]="address?.title">
                      {{
                      address?.title.length > 20
                              ? (address?.title | slice: 0:25) + "..."
                              : address?.title
                      }}
                    </h3>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <label for="city">City</label>
                      <span id="city">{{ address?.cityName }}</span>
                    </div>
                    <div class="col-md-6">
                      <label for="area">Area</label>
                      <span id="area">{{ address?.areaName }}</span>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-md-12">
                      <label for="address">Address</label>
                      <span id="address">{{ address?.details }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div
                      class="add-address address-card d-flex flex-column justify-content-center align-items-center"
                      (click)="openNotificationModal(addAddressModal)"
              >
              <span class="mb-3">
                <i class="icon-add-address"></i>
              </span>
                <h3 class="cta-address">Add New Address</h3>
              </div>
            </div>
          </form>

          <div class="row step-footer mt-4 mb-5">
            <button
                    type="submit"
                    class="btn btn-psp-primary btn-round"
                    (click)="goBack()"
            >
              Cancel
            </button>
            <button
                    type="submit"
                    class="btn btn-psp-primary btn-round"
                    [disabled]="!selectedAddress.patientAddressId"
                    (click)="changeStep(2)"
            >
              Next Step
            </button>
          </div>
        </div>
      </ng-template>

      <ng-template [ngIf]="stepCount == 2">
        <div
                class="row steps-action centered d-flex flex-column align-items-center justify-content-center"
        >
          <div class="header col-12">
            <h1>Request Information</h1>
            <h2>Please confirm the below information.</h2>
          </div>
          <div class="step-3-body body mb-4">
            <div class="card-body step-3">
              <h1 class="mb-2">Patient Details</h1>
              <div class="address">
                <div class="row">
                  <div class="col-6">
                    <label class="lab" for="">Name</label>
                    <h3 class="da">{{ patient?.personalInfo?.fullName }}</h3>
                  </div>
                  <div class="col-6">
                    <label class="lab" for="area">National Id</label>
                    <h3 class="da">{{ patient?.personalInfo?.nationalId }}</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <label class="lab" for="">Mobile Number</label>
                    <h3 class="da">{{ patient.personalInfo.phone }}</h3>
                  </div>
                  <div class="col-6">
                    <label class="lab" for="area">Program</label>
                    <h3 class="da">{{ selectedSubscription?.program?.name }}</h3>
                  </div>
                </div>
                <hr />
              </div>
              <h1 class="mb-2">Patient Address</h1>
              <div class="address">
                <div class="row">
                  <div class="city col-6">
                    <label class="lab" for="">City</label>
                    <h3 class="da">{{ selectedAddress.cityName }}</h3>
                  </div>
                  <div class="label col-6">
                    <label class="lab" for="area">Area</label>
                    <h3 class="da">{{ selectedAddress.areaName }}</h3>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label class="lab" for="address">Address</label>
                    <h3 class="da">{{ selectedAddress.details }}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="request-additional-fields">
            <div class="field-input-group" style="min-width: 130.19px;min-height: 74.5px;">
              <label for="foc">FOC</label>
              <input
                      class="input form-control"
                       type="text"
                      [min]="1"
                      [max]="isRocheProgram ? 6 : ''"
                      name="foc"
                      id="foc"
                      [(ngModel)]="requestFOC"
                      [disabled]="discountToggle"
                      (input)="onFocInput($event)"
                      (change)="onFocInput($event)"
                      (blur)="onFocInput($event)"
              />
            </div>
            <div class="field-input-group" style="min-width: 130.19px;min-height: 74.5px;">
              <label for="empty-boxes">Empty Boxes</label>
              <input
                      class="input form-control"
                      type="text"
                      [min]="isRocheProgram ? 0 : 1"
                      [max]="isRocheProgram ? 6 : ''"
                      name="empty-boxes"
                      id="empty-boxes"
                      [(ngModel)]="requestEmptyBoxes"
                       [disabled]="emptyBoxesDisabled()"
                      (input)="onEmptyBoxesInput($event)"
                      (change)="onEmptyBoxesInput($event)"
                      (blur)="onEmptyBoxesInput($event)"
              />
            </div>
            <div class="field-input-group">
              <label for="sales-purchase">Sales/Purchase</label>
              <input
                      class="input form-control"
                      type="number"
                      min="1"
                      name="sales-purchase"
                      id="sales-purchase"
                      [(ngModel)]="requestSalesPurchase"
                      [disabled]="discountToggle || isRocheProgram"
                      (input)="onBundleInput($event)"
              />
            </div>
            <div class="field-input-group">
              <label for="discount-toggle">Enable Discount</label>
              <label class="custom-toggle custom-toggle-default" (click)="$event.stopPropagation()">
                <input
                        [checked]="discountToggle"
                        type="checkbox"
                        id="discount-toggle"
                        (change)="changeToggle()"
                        [disabled]="isInsulinProgram"
                />
                <span class="custom-toggle-slider rounded-circle"></span>
              </label>
            </div>
          </div>
          <div *ngIf="discountToggle">
            <h3 class="discount-approach-title">Discount Approach</h3>
            <div class="request-additional-fields">
              <div class="field-input-group">
                <label for="Qty">Quantity</label>
                <input
                        class="input form-control"
                        type="text"
                        [min]="1"
                        [max]="isRocheProgram ? 6 : ''"
                        name="Quantity"
                        id="Qty"
                        [(ngModel)]="discountedItemsQuantity"
                        (input)="onDiscountQtyInput($event)"
                        (keyup)="calculateTotalPriceAfterDiscount()"
                        (change)="onDiscountQtyInput($event); calculateTotalPriceAfterDiscount()"
                        (blur)="onDiscountQtyInput($event); calculateTotalPriceAfterDiscount()"
                        required
                />
              </div>
              <div class="field-input-group">
                <label for="price">Public Price</label>
                <input
                        class="input form-control"
                        type="number"
                        min="1"
                        name="publicPrice"
                        id="price"
                        [(ngModel)]="programPublicPrice"
                        [readonly]="true"
                />
              </div>
            </div>
            <div class="request-additional-fields">
              <div class="field-input-group">
                <label for="discount">Discount Percentage %</label>
                <input
                        class="input form-control"
                        type="text"
                        name="discountPercentage"
                        min="1"
                        max="99"
                        maxlength="6"
                        id="discount"
                        [(ngModel)]="discountPercentage"
                        (input)="onDiscountPercentageChange($event)"
                        (change)="calculateTotalPriceAfterDiscount()"
                        (blur)="calculateTotalPriceAfterDiscount()"
                        required
                />
              </div>
              <div class="field-input-group">
                <label for="priceAfterDiscount">Total Price After Discount</label>
                <input
                        class="input form-control"
                        type="number"
                        name="totalPriceAfterDiscount"
                        id="priceAfterDiscount"
                        [(ngModel)]="totalPriceAfterDiscount"
                        [readonly]="true"
                />
              </div>
            </div>
          </div>
          <div class="note">
            <label for="note"> Additional Note <em>(optional)</em></label>
            <textarea
                    class="input"
                    type="text"
                    name="note"
                    id="note"
                    [(ngModel)]="RequestNotes"
            ></textarea>
          </div>
          <div class="row step-footer mt-4 mb-5">
            <button type="submit" class="btn outline" (click)="changeStep(1)">
              Back
            </button>
            <button
                    type="submit"
                    class="btn btn-psp-primary btn-round"
                    [disabled]="isRequestFormDisabled()"
                    (click)="onSubmit()"
            >
              Submit Request
            </button>
          </div>
        </div>
      </ng-template>
    </ng-template>
  </div>
</div>



